<template>
  <div class="settings-container" v-if="props.data">
    <Alert v-if="!chatYes"  svgName="lock" className="yellow">
        <p>
          Your current plan does not have access to this feature.
            <a v-if="Store.state.projectName !== 'cj'" :href="`mailto:${Store.state.mail_to_creator}?subject=${Store.state.user_data.merchant_account.merchant_display_name} - Upgrade to Custom Subdomain&body= Please provide your name and contact info. A representative will contact you in 1-2 business days.`" target="_blank">Contact us</a>
            <a v-else href="#" @click.prevent="openSupportForm">Contact us</a>
            to upgrade your account
        </p>
    </Alert>
    <!-- Manage messages section -->
    <div class="section-header" v-if="props.data.manageMessaging">
      <h3>Manage messages</h3>
      <el-select v-if="props.canEdit" v-model="props.data.manageMessaging.permission" default-first-option
        @change="handleMessageChange" :disabled="!chatYes">
        <el-option v-for="item in props.data.manageMessaging.permissionOption" :key="item.type" :label="item.name"
          :value="item.type" />
      </el-select>
      <span v-else>{{ switchParentText(props.data.manageMessaging.permission) }}</span>
    </div>

    <div class="setting-item indented" v-if="props.data.chatWithCreator">
      <span>Chat with creators</span>
      <div v-if="props.data.manageMessaging.permission !== 0">
        <Switch v-if="props.canEdit" :checked="props.data.chatWithCreator.permission === 100"
          @click.native="props.data.manageMessaging.permission == 50 ? null : switchItem(props.data, 'chatWithCreator.permission')"
          :disabled="props.data.manageMessaging.permission == 50 || !chatYes" />
        <span v-else>{{ switchText(props.data.chatWithCreator.permission) }}</span>
      </div>
    </div>

    <div class="setting-item indented" v-if="props.data.editWelcomeMessage">
      <span>Edit welcome message</span>
      <div v-if="props.data.manageMessaging.permission !== 0">
        <Switch v-if="props.canEdit" :checked="props.data.editWelcomeMessage.permission === 100"
          @click.native="props.data.manageMessaging.permission == 50 ? null : switchItem(props.data, 'editWelcomeMessage.permission')"
          :disabled="props.data.manageMessaging.permission == 50 || !chatYes" />
        <span v-else>{{ switchText(props.data.editWelcomeMessage.permission) }}</span>
      </div>
    </div>

    <div class="setting-item indented" v-if="props.data.sendOnlyOrDisableChat">
      <span>Disable creator's chat</span>
      <div v-if="props.data.manageMessaging.permission !== 0">
        <Switch v-if="props.canEdit" :checked="props.data.sendOnlyOrDisableChat.permission === 100"
          @click.native="props.data.manageMessaging.permission == 50 ? null : switchItem(props.data, 'sendOnlyOrDisableChat.permission')"
          :disabled="props.data.manageMessaging.permission == 50 || !chatYes" />
        <span v-else>{{ switchText(props.data.sendOnlyOrDisableChat.permission) }}</span>
      </div>
    </div>

    <!-- Manage announcements section -->
    <Alert v-if="!announcementsYes"  svgName="lock" className="yellow yellow-2">
        <p>
            Your current plan does not have access to this feature.
            <a v-if="Store.state.projectName !== 'cj'" :href="`mailto:${Store.state.mail_to_creator}?subject=${Store.state.user_data.merchant_account.merchant_display_name} - Upgrade to Custom Subdomain&body= Please provide your name and contact info. A representative will contact you in 1-2 business days.`" target="_blank">Contact us</a>
            <a v-else href="#" @click.prevent="openSupportForm">Contact us</a>
            to upgrade your account
        </p>
    </Alert>
    <div class="section-header section-header-2" v-if="props.data.manageAnnouncements">
      <h3>Manage announcements</h3>
      <el-select v-if="props.canEdit" v-model="props.data.manageAnnouncements.permission" default-first-option
        @change="handleAnnouncementsChange" :disabled="!announcementsYes">
        <el-option v-for="item in props.data.manageAnnouncements.permissionOption" :key="item.type" :label="item.name"
          :value="item.type" />
      </el-select>
      <span v-else>{{ switchParentText(props.data.manageAnnouncements.permission) }}</span>
    </div>

    <div class="setting-item indented" v-if="props.data.draftAndScheduleAndPublishAnnouncements">
      <span>Draft, schedule, and publish announcements</span>
      <div v-if="props.data.manageAnnouncements.permission !== 0">
        <Switch v-if="props.canEdit"
          :checked="props.data.draftAndScheduleAndPublishAnnouncements.permission === 100"
          @click.native="props.data.manageAnnouncements.permission == 50 ? null : switchItem(props.data, 'draftAndScheduleAndPublishAnnouncements.permission')"
          :disabled="props.data.manageAnnouncements.permission == 50 || !announcementsYes" />
        <span v-else>{{ switchText(props.data.draftAndScheduleAndPublishAnnouncements.permission) }}</span>
      </div>
    </div>

    <div class="setting-item indented" v-if="props.data.disableOrDeletePublishedAnnouncements">
      <span>Delete published announcements</span>
      <div v-if="props.data.manageAnnouncements.permission !== 0">
        <Switch v-if="props.canEdit" :checked="props.data.disableOrDeletePublishedAnnouncements.permission === 100"
          @click.native="props.data.manageAnnouncements.permission == 50 ? null : switchItem(props.data, 'disableOrDeletePublishedAnnouncements.permission')"
          :disabled="props.data.manageAnnouncements.permission == 50 || !announcementsYes" />
        <span v-else>{{ switchText(props.data.disableOrDeletePublishedAnnouncements.permission) }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed, watch, onMounted, getCurrentInstance } from 'vue';
const { proxy } = getCurrentInstance();
const EventBus = proxy.EventBus;
const openSupportForm = () => EventBus.emit('open-global-drawer', 'help-support');
import Switch from '@/components/ui/Switch.vue';
import { ElSelect, ElOption } from 'element-plus';
import { useTeamFunction } from './teamFunction';
import Alert from '@/components/settings/SettingAlert.vue';
import Store from '@/store/index.js';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  },
  isOwner: {
    type: Boolean,
    default: false
  },
  canEdit: {
    type: Boolean,
    default: false
  }
});
const { switchItem,switchText,switchParentText } = useTeamFunction();
const announcementsYes=computed(() => {
  return Store.state.user_data?.merchant_account?.is_enable_announcement;
});
const chatYes=computed(() => {
  return Store.state.user_data?.merchant_account?.is_enable_chatroom;
});
// +++++++++++++++++++++++++++++
const handleMessageChange = (event) => {
  let val = event !== 100 ? 0 : 100;
  props.data.chatWithCreator.permission = val;
  props.data.editWelcomeMessage.permission = val;
  props.data.sendOnlyOrDisableChat.permission = val;
};
const handleAnnouncementsChange = (event) => {
  let val = event !== 100 ? 0 : 100;
  props.data.draftAndScheduleAndPublishAnnouncements.permission = val;
  props.data.disableOrDeletePublishedAnnouncements.permission = val;
};

// +++++++++++++++++++++++++++++
// +++++++++++++++++++++++++++++
onMounted(() => {
 
  setTimeout(()=>{
    if (!announcementsYes.value) {
      props.data.manageAnnouncements.permission = 50;
      handleAnnouncementsChange(0);
    }

    if (!chatYes.value) {
      props.data.manageMessaging.permission = 50;
      handleMessageChange(0);
    }
  },1000)

});
</script>

<style>
</style>